<template>
  <div class="card">
    <h2 class="title">保障方案选择</h2>
    <div class="base-container flex">
      <div class="item-title">
        <p>基本方案</p>
        <p>地理涵盖范围</p>
        <p>医院涵盖范围</p>
        <p>住院免赔额</p>
        <p>常驻地区</p>
        <p>体检</p>
        <p>牙科</p>
      </div>
      <div class="flex plan-container">
        <div class="plan-item" v-for="(item, index) in riskInfo" :key="item.index">
          <div class="plan-title" :style="{backgroundColor: colors[index%4]}">保障计划{{index+1}}</div>
          <div class="content">
            <a-select @change="planChange" v-model="item.plan">
              <a-select-option v-for="option in planList" :key="option.code" :value="option.code">{{ option.name }}</a-select-option>
            </a-select>
            <a-select @change="planChange" v-model="item.dl">
              <a-select-option v-for="option in rangeList" :key="option.code" :value="option.code">{{ option.name }}</a-select-option>
            </a-select>
            <a-select @change="planChange" v-model="item.yy">
              <a-select-option v-for="option in hosRangeList" :key="option.code" :value="option.code">{{ option.name }}</a-select-option>
            </a-select>
            <a-select @change="planChange" v-model="item.mp">
              <a-select-option v-for="option in mpList" :key="option.code" :value="option.code">{{ option.name }}</a-select-option>
            </a-select>
            <a-select @change="planChange" v-model="item.cz">
              <a-select-option v-for="option in areaList" :key="option.code" :value="option.code">{{ option.name }}</a-select-option>
            </a-select>
            <a-select @change="planChange" v-model="item.tj">
              <a-select-option v-for="option in tjList" :key="option.code" :value="option.code">{{ option.name }}</a-select-option>
            </a-select>
            <a-select @change="planChange" v-model="item.yk">
              <a-select-option v-for="option in ykList" :key="option.code" :value="option.code">{{ option.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="plan-item">
          <div class="plan-title" :style="{backgroundColor: colors[riskInfo.length%4]}"></div>
          <div class="content flex add-one" @click="addNewPlan">+</div>
        </div>
      </div>
    </div>
    <div class="flex base-container age-container">
      <h2 class="age-title">投保人数</h2>
      <div class="item-title">
        <p>年龄段（周岁）</p>
        <p v-for="item in ageList" :key="item">{{item}}</p>
      </div>
      <div class="flex plan-container ages">
        <div class="plan-item" v-for="(item, index) in riskInfo" :key="'age'+item.index">
          <div class="plan-title" :style="{backgroundColor: colors[index%4]}">保障计划{{index+1}}</div>
          <div class="content">
            <a-input @blur="insureNumBlur($event, riskInfo[index].insList[i])" v-for="(age, i) in ageList" :key="index+age+i" v-model="item.insList[i].mult" placeholder="请输入投保人数" suffix="人"></a-input>
          </div>
        </div>
        <div class="plan-item">
          <div class="plan-title" :style="{backgroundColor: colors[riskInfo.length%4]}"></div>
          <div class="content flex premium">
            <div>
              <p>合计</p>
              <p>人数：{{baseInfo.total_mult || 0}}人</p>
              <p>保费：{{baseInfo.totalPremium || 0}}元</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as codeList from "../js/data";

export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    initRiskData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ...codeList,
      riskItem: {
        plan: "1",
        dl: "ZGDL",
        yy: "001",
        mp: "0",
        cz: "0",
        tj: "0",
        yk: "0",
        insList: []
      },
      riskInfo: [],
      colors: ["#282e6a", "#e3af6d", "#949254", "#afd7f2"]
    }
  },
  mounted() {
    this.initRiskInfo();
  },
  methods: {
    // 增加计划信息
    addNewPlan() {
      this.riskInfo.push({
        index: this.riskInfo.length + 1,
        ...this.$lodash.cloneDeep(this.riskItem)
      });
      this.$emit("setRiskInfo", this.riskInfo)
    },
    // 初始化生成三条计划信息
    initRiskInfo() {
      this.ageList.forEach(item => {
        this.riskItem.insList.push({
          age: item,
          mult: undefined,
        })
      })
      if(this.initRiskData && this.initRiskData.length) {
        debugger
        let count = 1;
        for(let i = 0; i < this.initRiskData.length; i ++) {
          console.log(count, this.initRiskData[i].index)
          while (count < this.initRiskData[i].index) {
            this.riskInfo.push({
              index: count,
              ...this.$lodash.cloneDeep(this.riskItem)
            });
            count ++
          }
          console.log(count, this.initRiskData[i].index)
          if(this.initRiskData[i].index === count) {
            this.riskInfo.push({
              ...this.$lodash.cloneDeep(this.riskItem),
              ...this.initRiskData[i]
            })
            count ++
          }
        }
      } else {
        for (let i = 1; i <= 3; i ++) {
          this.riskInfo.push({
            index: i,
            ...this.$lodash.cloneDeep(this.riskItem)
          });
        }
      }
      this.$emit("setRiskInfo", this.riskInfo)
    },
    // 计划修改 触发人员清单模块的保费计算
    planChange() {
      this.$emit("setRiskInfo", this.riskInfo)
      this.priceComputed();
    },
    // 输入投保人数
    insureNumBlur(e, data) {
      const val = e.target.value;
      if (val && !/^[0-9]+$/.test(val)) {
          this.$message.error('投保人数请输入正整数')
          data.mult = undefined;
      }
      this.priceComputed();
    },
    // 算费 过滤用有人数的计划去算费
    priceComputed(noValiadte = true) {
      this.riskInfo.forEach(item => {
        let r_mult = 0;
        item.insList.forEach(age => {
          if(age.mult) {
            r_mult += age.mult * 1;
          }
        })
        item.r_mult = r_mult;
      })
      let total_mult = 0
      let data = [], noMultItem = [];
      // let data = this.$lodash.cloneDeep(this.riskInfo);
      for (let i = 0; i < this.riskInfo.length; i ++) {
        if(this.riskInfo[i].r_mult > 0) {
          total_mult += this.riskInfo[i].r_mult;
          data.push(this.$lodash.cloneDeep(this.riskInfo[i]))
        } else {
          noMultItem.push('保障计划'+(i+1))
        }
      }
      data.forEach(item => {
        item.insList = item.insList.filter((aItem) => {
          return aItem.mult;
        })
      })
      return new Promise((resolve) => {
        // 三人起保
        if(!total_mult || total_mult < 3) {
          this.handleError(noValiadte, "最低投保人为3人");
          resolve(false)
          return false;
        }
        // 未录入投保人数的计划过滤掉 然后做不阻断提示
        if(noMultItem && noMultItem.length) {
          this.handleError(noValiadte, noMultItem.join(',')+'未添加投保人数，未加入算费信息中');
        }
        // 投保人数试算，shisuan默认传0
        this.$emit("priceComputed", {total_mult, riskInfos: data, shisuan: "0"});
        resolve(true)
      })
    },
    // 算费提示信息处理
    handleError(noValiadte, errorMsg){
      if(noValiadte || !errorMsg){
        return;
      }
      this.$message.error(errorMsg);
    }
  }

}
</script>

<style lang="scss" scoped>
.flex{
  display: flex;
  align-items: normal
}
.base-container{
  position: relative;
  margin: 70px 10px 0;
  padding: 20px 0 20px;
  background-color: #efefef;
  .item-title{
    width: 300px;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    line-height: 2;
    text-align: center;
    p{
      margin-bottom: 10px;
    }
  }
  .plan-container {
    width: calc(100% - 300px);
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: -60px;
    .content{
      padding: 0 5px;
    }
  }
  .plan-item{
    flex-shrink: 0;
    width: 220px;
    margin: 0 5px;
    background-color: #fff;
    box-sizing: border-box;
  }
  .plan-title{
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    line-height: 40px;
    height: 40px;
    margin-bottom: 20px;
    border-radius: 20px 20px 0 0;
  }
  .add-one{
    min-height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 50px;
    color: #020a76;
    cursor: pointer;
  }
  .premium {
    min-height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    text-align: center;
    font-weight: bold;
  }
  .ages {
    margin-top: -10px;
    .plan-title{
      border-radius: 0 0 20px 20px;
    }
  }
  ::v-deep .ant-select,
  .ant-input-affix-wrapper{
    width: 100%;
    margin-bottom: 18px;
  }
}
.age-container{
  margin-top: 20px;
  padding-top: 40px;
  .age-title{
    position: absolute;
    left: 50%;
    top: -25px;
    width: 400px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color:#020a76;
    color: #fff;
    transform: translateX(-50%);
  }
}
</style>